/**
 * 通知相關enum
 */
export namespace NOTIFY_ENUM {

    /**
     * 通知類型
     * 
     *      TEST_MAIL 測試信
     *      BIRTHDAY_LIST 壽星清單
     *      RESET_PASSWORD 重置密碼
     *      ASINK_AUTO_DRAW_CONTACT_US 自動繪圖聯絡我們
     */
    export const NOTIFY_METHOD = {
        TEST_MAIL: 0,
        BIRTHDAY_LIST: 1,
        RESET_PASSWORD: 2,
        ASINK_AUTO_DRAW_CONTACT_US: 3
    }
}